/* eslint-disable */
import styled from 'styled-components'
import { trainButtonBackgroundMap, TrainButtonState } from './util/button'

const Container = styled.div`
  height: 100%;
`

const FiltersContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;
`

const SubHeader = styled.div`
  font-size: 14px;
  color: #616581;
`

const getTrainButtonStyles = (state: TrainButtonState) => {
  const isInactiveOrTrained = state === TrainButtonState.TRAINED || state === TrainButtonState.INACTIVE
  return {
    cursor: isInactiveOrTrained ? 'default' : 'pointer',
    pointerEvents: isInactiveOrTrained ? 'none' : 'auto',
    background: trainButtonBackgroundMap[state] || trainButtonBackgroundMap[TrainButtonState.ACTIVE],
    opacity: state === TrainButtonState.TRAINED ? 0.6 : 1,
  }
}

export type TrainButtonProps = {
  state?: TrainButtonState
}

const ModalButton = styled.button<TrainButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 10px;
  outline: none;
  box-shadow: 0 3px 9px rgba(19, 69, 186, 0.206267);
  color: white;
  border: none;
  max-width: fit-content;
  min-width: fit-content;
  ${({ state }) => {
    const styles = getTrainButtonStyles(state)
    return `
      cursor: ${styles.cursor};
      pointer-events: ${styles.pointerEvents};
      background: ${styles.background};
      opacity: ${styles.opacity};
    `
  }};
  transition: opacity 0.3s ease;
`

const CancelButton = styled(ModalButton)`
  background: white;
  color: black;
`

const RemoveButton = styled(ModalButton)`
  background: linear-gradient(285.2deg, #ff7961 -35.9%, #f44336 61.17%);
`

const ModalIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  width: 100%;
  height: 100%;
  cursor: pointer;
`

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem 1rem 1rem;
`

const AnswerInput = styled.textarea`
  padding: 10px;
  outline: none;
  width: 100%;
  border-radius: 10px;
  font-size: 14px;
  line-height: 19px;
  background-color: white;
  color: black;
  border: 1px solid #c7cad6;
  min-height: 100px;
`

const AnswerText = styled.div`
  width: 100%;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
`

const TitleIconWrapper = styled.span`
  padding-left: 8px;
`

const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`

const Label = styled(AnswerText)`
  max-width: fit-content;
  font-weight: 500;
  font-size: 0.7rem;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  padding: 0 5px;

  &:hover {
    background: rgba(0, 51, 255, 0.18);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  }
`

export {
  Container,
  SubHeader,
  ModalButton,
  RemoveButton,
  CancelButton,
  AnswerInput,
  AnswerText,
  ModalIconContainer,
  TitleIconWrapper,
  ModalContainer,
  ModalButtonContainer,
  FiltersContainer,
  Label,
}
